import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import EditorField from 'builder/components/EditorField'
import { TextField } from 'builder/components/TextField'
import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions } from 'builder/modules/resumeEditor'

export const FullName = () => {
  const namePronunciation = useTypedSelector(state => state.resumeEditor.resume?.namePronunciation)
  const dispatch = useDispatch()
  const { updateSimpleField } = actions
  const { i18n } = useI18n()

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target
      dispatch(updateSimpleField({ name: 'namePronunciation', value, debounce: true }))
    },
    [dispatch, updateSimpleField],
  )

  return (
    <>
      {/* First name */}
      <EditorField>
        <TextField
          label={i18n.t('builder.resume_editor.name_pronunciation')}
          value={namePronunciation || ''}
          name="namePronunciation"
          onChange={handleChange}
        />
      </EditorField>
    </>
  )
}
